import { api } from "./client";
import type {
  AdminLoginResponse,
  AdminStartResponse,
  PasskeyLoginResponse,
  EnrollmentCompleteResponse,
  EnrollmentStartResponse,
  GenericMessage,
  SessionAuthResponse,
  SessionInfo,
} from "./types";

export const authApi = {
  session: () => api.get<SessionInfo>("/auth/session"),
  adminLogin: (email: string, password: string) =>
    api.post<AdminLoginResponse>("/auth/admin/login", { email, password }),
  changeTempPassword: (current_password: string, new_password: string) =>
    api.post<AdminLoginResponse>("/auth/admin/password/change", { current_password, new_password }),
  adminStart: (email: string) => api.post<AdminStartResponse>("/auth/admin/start", { email }),
  passkeyOptions: () => api.post<{ challenge_id: string; options: Parameters<typeof import("@simplewebauthn/browser").startAuthentication>[0]["optionsJSON"] }>("/auth/admin/passkey/options"),
  passkeyVerify: (challenge_id: string, credential: unknown) =>
    api.post<PasskeyLoginResponse>("/auth/admin/passkey/verify", { challenge_id, credential }),
  verifyTotp: (code: string, remember_device = false) => api.post<SessionAuthResponse>("/auth/admin/mfa/verify", { code, remember_device }),
  verifyBackupCode: (code: string, remember_device = false) =>
    api.post<SessionAuthResponse>("/auth/admin/mfa/backup-code", { code, remember_device }),
  startEnrollment: () => api.post<EnrollmentStartResponse>("/auth/admin/mfa/enroll/start"),
  completeEnrollment: (code: string) =>
    api.post<EnrollmentCompleteResponse>("/auth/admin/mfa/enroll/verify", { code }),
  requestEmployeeCode: (email: string) => api.post<GenericMessage>("/auth/employee/request-code", { email }),
  verifyEmployeeCode: (email: string, code: string) =>
    api.post<SessionAuthResponse>("/auth/employee/verify-code", { email, code }),
  logout: () => api.post<GenericMessage>("/auth/logout"),
};
